import { Badge, List, Skeleton } from 'antd'
import Avatar from 'components/Avatar'
import Button from 'components/Button'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import EllipseDot from 'components/icons/EllipseDot'
import {
  BottomFLex,
  ButtonFlex,
  FlexWrapper,
  InfoWrap,
  LightText,
  NotifyDiv,
  NotifyTexBold,
  NotifyText,
} from 'modules/Page/Components/Partials/NotificationDrawer/AllNotificationDetails/style'
import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { getPromotion } from '../../../../../Roles/actions'
import CandidateInfo from '../../InterviewDetails/CandidateInfo/index'

const NotificationDetails = ({
  notificationData,
  notification,
  setNotification,
  notificationAsRead,
  loading,
  hasMoreData,
  setHasMoreData,
  listData,
  pageNo,
  setPageNo,
  driveData,
  getSingleCandidateInterviewDetails,
  updateInterviewStatus,
  candidateInterviewDetails,
  rolesMetrics,
  getRoleMetrics,
  getRescheduleList,
  notifyReschedule,
  addCorporateBranch,
  candidateDetails,
  getCandidateDetails,
  getRoleRounds,
  roundItemList,
  onCloseParentDrawer,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  listOfCountries,
  listOfStates,
  listOfCities,
  interViewerList,
  createInterview,
  driveId,
  roleId,
  driveInterViewerList,
  getDriveInterviewerList,
  getCandidateList,
  getInterViewLocation,
  interViewData,
  corporateLocationsList,
  getCorporateLocationsList,
  groupList,
  groupCandidateList,
  getGroupDiscussionList,
  UpdateScheudle,
  getDriveRoleCandidatesList,
}) => {
  const navigate = useNavigate()
  const dispatch = new useDispatch()
  const params = useParams()
  const [showCandidateInfo, setShowCandidateInfo] = useState(false)
  const [candidateLoading, setCandidateLoading] = useState(false)
  const [scheduleDrawer, setScheduleDrawer] = useState(false)
  const [candidateInfoData, setCandidateInfoData] = useState(notifyReschedule)
  const [selectedRoundType, setSelectedRoundType] = useState('')
  const [selectedCandidateId, setSelectedCandidateId] = useState([])
  const [selectedCandidate, setSelectedCandidate] = useState([])
  const [status] = useState('SCHEDULED,SHORTLISTE,PENDINGD')
  const [currentPage] = useState(0)
  const [reasonItem, setReasonItem] = useState('')
  const [searchParams] = useSearchParams()

  const stage = searchParams.get('stage')

  useEffect(() => {
    setCandidateInfoData(notifyReschedule)
  }, [notifyReschedule])

  useEffect(() => {
    let candidateStage =
      stage === 'all_candidates' ? candidateInfoData?.stage : stage
    const selectedRoundObj = rolesMetrics[0]?.rounds.filter(round => {
      if (round?.roundName === candidateStage) return round
    })[0]
    setSelectedRoundType(selectedRoundObj)
    if (selectedRoundObj?.type === 'GROUP' && status !== 'SHORTLISTED')
      if (params?.roleId && params?.expcandidatesId) getGDList()
  }, [stage, rolesMetrics, params, currentPage, candidateInfoData, status])

  const getGDList = () => {
    getGroupDiscussionList(
      params?.roleId,
      params?.expcandidatesId,
      stage,
      status === 'SCHEDULED,SHORTLISTED,PENDING' ? 'ACTIVE' : status,
      currentPage
    )
  }

  useEffect(() => {
    if (listData?.length) {
      let payload = {
        notificationId: notificationData?.list[0]?._id,
      }
      if (!notificationData?.list[0]?.is_read) {
        notificationAsRead(payload)
      }
    }
  }, [listData])

  const fetchMoreData = () => {
    if (notificationData?.totalPages == pageNo) {
      setHasMoreData(false)
      return
    }
    if (notification) {
      setPageNo(prev => prev + 1)
    }
  }

  const pageNavigate1 = (data, navLink) => {
    if (data?.body?.includes('closed')) {
      ErrorMessage('Job Role Closed')
      setNotification(false)
      navigate('/rolePage')
    } else {
      setNotification(false)
      navigate(navLink)
    }
  }
  const [ids, setIds] = useState()

  const onRescheduleBtn = data => {
    setShowCandidateInfo(true)
    const { driveId, roleId, studentId, reason } = data?.parameters || {}
    dispatch(getPromotion(studentId))
    getRescheduleList({ driveId, roleId, studentId })
    getRoleRounds(roleId)
    setReasonItem(reason)
    onCloseParentDrawer(false)
    getCandidateDetails({ studentId, setCandidateLoading })
    getRoleMetrics(driveId)
    getSingleCandidateInterviewDetails(roleId, driveId, studentId)
    getDriveInterviewerList(driveId)
    setIds(data)
  }

  return (
    <>
      <NotifyDiv>
        <InfiniteScroll
          dataLength={listData?.length}
          next={fetchMoreData}
          hasMore={hasMoreData}
          loader={
            hasMoreData ? (
              <Skeleton avatar paragraph={{ rows: 2 }} active />
            ) : null
          }
          height={'80vh'}
        >
          <List
            bordered={false}
            dataSource={listData}
            loading={loading}
            renderItem={(item, index) => (
              <Fragment key={index}>
                <List.Item>
                  <FlexWrapper key={index} row>
                    <Badge dot={!item?.is_read} offset={[-10, 5]}>
                      <Avatar
                        title={item?.is_read ? '' : 'New'}
                        background="#F2F3F5"
                        src={item?.icon}
                        size={46}
                        IconName={item?.issuer?.charAt(0)?.toUpperCase()}
                      />
                    </Badge>

                    <InfoWrap column>
                      <NotifyText>
                        {!!item?.issuer && (
                          <NotifyTexBold>'{item?.issuer}'</NotifyTexBold>
                        )}
                        {!!item?.body && `  ${item?.body}`}
                      </NotifyText>
                      {!!item?.actions?.length && item?.actions?.length > 1 && (
                        <ButtonFlex>
                          {item?.actions
                            .slice()
                            .sort((a, b) =>
                              a.name === 'Reject Request' ? -1 : 1
                            )
                            .map((data, kIndex) =>
                              data?.name === 'Reject Request' ? (
                                <Button.Secondary
                                  text={data?.name}
                                  height={'32px'}
                                  fontWeight={600}
                                  onClick={() => onRescheduleBtn(data)}
                                  key={data?.name + kIndex}
                                />
                              ) : (
                                <Button.Primary
                                  text={data?.name}
                                  height={'32px'}
                                  onClick={() => onRescheduleBtn(data)}
                                  key={data?.name + kIndex}
                                />
                              )
                            )}
                        </ButtonFlex>
                      )}
                      {!!item?.actions?.length &&
                        item?.actions?.length === 1 &&
                        !item?.body?.includes('closed') && (
                          <ButtonFlex>
                            {item?.actions?.map((data, kIndex) => (
                              <Button.Primary
                                text={data?.name}
                                height={'32px'}
                                onClick={() => pageNavigate1(item, data?.route)}
                                key={data?.name + kIndex}
                              />
                            ))}
                          </ButtonFlex>
                        )}

                      <BottomFLex alignCenter>
                        <LightText>
                          {moment(item?.created_at).fromNow(true)} ago
                        </LightText>
                        <EllipseDot />
                        <LightText>{item?.tag}</LightText>
                      </BottomFLex>
                    </InfoWrap>
                  </FlexWrapper>
                </List.Item>
              </Fragment>
            )}
          />
        </InfiniteScroll>
      </NotifyDiv>
      <CandidateInfo
        driveData={driveData}
        candidateInfo={showCandidateInfo}
        setCandidateInfo={setShowCandidateInfo}
        scheduleDrawer={scheduleDrawer}
        setScheduleDrawer={setScheduleDrawer}
        rolesMetrics={rolesMetrics}
        candidateInfoData={candidateInfoData}
        updateInterviewStatus={updateInterviewStatus}
        getRescheduleList={getRescheduleList}
        notifyReschedule={notifyReschedule}
        selectedRoundType={selectedRoundType}
        getRoleMetrics={getRoleMetrics}
        setSelectedCandidate={setSelectedCandidate}
        setSelectedCandidateId={setSelectedCandidateId}
        selectedCandidate={selectedCandidate}
        selectedCandidateId={selectedCandidateId}
        getSingleCandidateInterviewDetails={getSingleCandidateInterviewDetails}
        addCorporateBranch={addCorporateBranch}
        candidateInterviewDetails={candidateInterviewDetails}
        setCandidateInfoData={setCandidateInfoData}
        getCandidateDetails={getCandidateDetails}
        candidateDetails={candidateDetails}
        getRoleRounds={getRoleRounds}
        roundItemList={roundItemList}
        interViewerList={interViewerList}
        createInterview={createInterview}
        driveId={driveId}
        roleId={roleId}
        driveInterViewerList={driveInterViewerList}
        getDriveInterviewerList={getDriveInterviewerList}
        getCandidateList={getCandidateList}
        getInterViewLocation={getInterViewLocation}
        getListOfCountries={getListOfCountries}
        getListOfStates={getListOfStates}
        getListOfCities={getListOfCities}
        listOfCountries={listOfCountries}
        listOfStates={listOfStates}
        listOfCities={listOfCities}
        interViewData={interViewData}
        corporateLocationsList={corporateLocationsList}
        getCorporateLocationsList={getCorporateLocationsList}
        groupCandidateList={groupCandidateList}
        groupList={groupList}
        getGroupDiscussionList={getGroupDiscussionList}
        UpdateScheudle={UpdateScheudle}
        ids={ids}
        setNotification={setNotification}
        notificationData={notificationData}
        reasonItem={reasonItem}
        getDriveRoleCandidatesList={getDriveRoleCandidatesList}
        candidateLoading={candidateLoading}
      />
    </>
  )
}

export default NotificationDetails
